export default class ConsentWidget implements IConsentWidget, IDigitalIdentityHubModule {
  public name = "ConsentWidget";

  public consentHubEndpoint = "";
  public consentHubCssEndpoint = "";
  public consentChannels = null;
  public unsubscribeReasonMandatory = false;

  public ready(): void {
    if (!this.consentChannels) {
      return;
    }

    function waitForConsentWidget(): Promise<void> {
      return new Promise(resolve => {
        const interval = setInterval(() => {
          if ((window as Window).$dynamit) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
    }

    function filterChannels(channels: object): object {
      if (!channels) {
        console.log("Consent Widget: consentChannels property is empty, skipping");
        return;
      }

      const channelsToDisplayParam = window.DigitalIdentityHub.utilities.getParameterByName("channels");
      const channelsToDisplay = channelsToDisplayParam?.split(",");

      if (channelsToDisplayParam) {
        channels = channelsToDisplay.reduce((accumulator, currentValue) => {
          if (channels[currentValue]) {
            accumulator[currentValue] = channels[currentValue];
          }
          return accumulator;
        }, {});
      }

      channels = window.DigitalIdentityHub.utilities.removeNulls(channels);
      return channels;
    }

    function renderDynamit(params: IDynamitParams) {
      const renderTo = document.getElementById("ConsentHubHost");

      if (!!renderTo && params.systemId) {
        (window as Window).$dynamit_default_params = params;
        (window as Window).$dynamit.default.renderCustomerConsentModel(renderTo, params);
      }
    }

    if (this.consentHubEndpoint) {
      window.DigitalIdentityHub.utilities.addScript(this.consentHubEndpoint, false);
      if (this.consentHubCssEndpoint) {
        window.DigitalIdentityHub.utilities.addLink(this.consentHubCssEndpoint, "text/css", "stylesheet", false);
      }
      const token = window.DigitalIdentityHub.utilities.getParameterByName("imtoken");
      const localProfile = JSON.parse(localStorage.janrainCaptureProfileData || "{}");
      if (token) {
        void Promise.all([
          fetch(`${window.DigitalIdentityHub.settings.deeplinkEndpoint}/accessToken?imtoken=${token}&clientid=${janrain.settings.capture.clientId}`).then(r => r.text()),
          fetch(`${window.DigitalIdentityHub.settings.deeplinkEndpoint}/consent?imtoken=${token}`).then(r => r.json()),
          waitForConsentWidget()
        ])
          .then(([accessToken, deeplinkProfile]) => ({
            id: "MCConsentEdit",
            system: "JNR",
            systemId: deeplinkProfile.uuid,
            countryCode: deeplinkProfile.registrationCountry,
            language: janrain.settings.language.split("-")[0],
            mdmId: deeplinkProfile.mdmId,
            channels: filterChannels(this.consentChannels(deeplinkProfile)),
            token: accessToken,
            unsubscribeReasonMandatory: this.unsubscribeReasonMandatory
          }))
          .then(renderDynamit);
      } else {
        void waitForConsentWidget()
          .then(() => ({
            id: "MCConsentEdit",
            system: "JNR",
            systemId: localProfile.uuid,
            countryCode: localProfile.registrationCountry || window.DigitalIdentityHub.utilities.getCountryCode(),
            language: janrain.settings.language.split("-")[0],
            mdmId: localProfile.mdmId,
            channels: filterChannels(this.consentChannels(localProfile)),
            token: localStorage.janrainCaptureToken,
            unsubscribeReasonMandatory: this.unsubscribeReasonMandatory
          }))
          .then(renderDynamit);
      }
    }
  }

  public init(): void { /* No functionality */ }
}
